import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form'

interface FormCheckboxProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
  label: string
}

export function FormCheckbox<TFieldValues extends FieldValues>({
  control,
  name,
  label,
}: FormCheckboxProps<TFieldValues>) {
  const { field } = useController({ control, name })

  return (
    <div className="form-check mb-3">
      <input
        {...field}
        type="checkbox"
        id={name}
        className="form-check-input"
        checked={!!field.value}
        onChange={(e) => field.onChange(e.target.checked)}
      />
      <label htmlFor={name} className="form-check-label">
        {label}
      </label>
    </div>
  )
}
